// months to suspend due to COVID
export const COVID_SUSPENSION_START = '2020-04-01';
export const COVID_SUSPENSION_END = '2020-08-31';
